module.exports = __webpack_public_path__ + "fonts/fa-duotone-900.60d8eaf6cac181aa93f0ffa2bd666267.eot";